import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ShareComponent } from './share.component';
import { ShareHistoryComponent } from './share-history/share-history.component';
import { ShareCertificateComponent } from './share-certificate/share-certificate.component';

const routes: Routes = [
  {
    path: '',
    component: ShareComponent,
    children: [
      {
        path: '',
        component: ShareCertificateComponent,
        data: {
          title: "Sharing Certificate",
          titleI18n: "GENERAL.SHARING_CERTIFICATE",
        },
      },
      {
        path: 'history',
        component: ShareHistoryComponent,
        data: {
          title: "Sharing Certificate",
          titleI18n: "CORE.MENU.HISTORY",
        },
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShareRoutingModule { }
